import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewChildren,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { MatTabGroup } from '@angular/material/tabs';
import { RootScope } from '@eninvoice-core/services/rootscope';
import { FileUpload } from '@material';
import { translate } from '@ngneat/transloco';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, filter, Subject, Subscription, takeUntil } from 'rxjs';
import { ApiService } from '../../services/api/api.service';

import { AssetData } from '../../models/assetdata.class';
import { AssetService } from '../../models/assetservice.class';
import { BridgeNode } from '../../models/bridgeNode.interface';
import { FilingAttributeField } from '../../models/filingattributefield.class';
import { Organization, OrganizationData } from '../../models/organization.class';
import { RequestBusinessKeysPayload } from '../../models/payload/businesskeys.class';
import { Record } from '../../models/record/record.class';
import { Search } from '../../models/search.class';
import { Transformation } from '../../models/transformation';
import { AssetsService } from '../../services/assets/assets.service';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { InstancesService } from '../../services/instances/instances.service';
import { NewProcessService } from '../../services/new-process/new-process.service';
import { RequestsService } from '../../services/requests/requests.service';
import { TransformationsService } from '../../services/transformations/transformations.service';
import { UtilsService } from '../../services/utils/utils.service';
import { ValidationsService } from '../../services/validations/validations.service';
import { environment } from '@env';

import {
    AlertError,
    CreateRequestViaSearch,
    GetActiveTransformationsByType,
    GetAppMetaData,
    GetAppSearchFilters,
    GetAppThroughAppName,
    GetAssetWithLatestVersion,
    GetInboundDetailedTransformations,
    SavedSearchCriteria,
    SaveSearchCriteria,
    SetAppSearchFilters,
    SetRequest,
} from '../../store/actions';
import {
    getAppMetaData$,
    getAppSearchOrganizationMap$,
    getAssetsWithLatestVersion$,
    getCurrentOrganization$,
    getFileUploadTransformations$,
    getSearchAssetTransformations$,
    getSearchOrAssetToAssetTransformations$,
    getSubscribedApps$,
} from '../../store/selectors';
import { UpdateRequestComponent } from '../updateRequestModal/updaterequest.component';

@Component({
    selector: 'lib-new-process',
    templateUrl: './new-process.component.html',
    styleUrls: ['./new-process.component.scss'],
    standalone: false,
})
export class NewProcessComponent implements OnInit {
    @Input() filingAttributeFields: any[];
    @Input() businessKeysRecord: Record;
    @Input() currentApp: AssetService;
    @Input() currentBridge: AssetService;
    @Input() currentReport: BridgeNode | AssetService;
    @Input() currentOrganizationId: string;
    @Input() assetMetaData: AssetData;
    @Input() taxillaApiUrl: string;
    @Input() isEninvoice: boolean;
    @Input() serviceId: string;
    @Input() restApiName: string;
    @Input() isCustomNewRequest = false;

    @Output() navigateToProcesses = new EventEmitter();
    @Output() navigateToInstancePage = new EventEmitter();
    @Output() navigateToInboundTransmissionsFromNewProcessPage = new EventEmitter();
    @Output() navigateToSourceAsset = new EventEmitter();
    @Output() navigateToEditPage = new EventEmitter();

    @ViewChildren('stepper') stepperList: QueryList<MatStepper>;

    get stepper(): MatStepper | undefined {
        return this.stepperList && this.stepperList.length > 0 ? this.stepperList.first : undefined;
    }
    @ViewChild('nextBtn', { static: true }) nextBTnDiv: ElementRef;
    @ViewChild('notificationPopupModal') notificationModal: TemplateRef<any>;
    @ViewChild('inputTypeGroup') inputTypeGroup: MatTabGroup;

    @Input() fieldsMap: BehaviorSubject<{
        [property: string]: {
            keyColumns: string[];
            valuesMap: { id: string; entityId: string; masterColumn: string; value: any; references: any[] }[];
        };
    }> = new BehaviorSubject(undefined);

    bridgeSourceNodes = [];
    transformations: { orgName: string; transformations: Transformation[]; repositoryId: string }[] = [];
    assetToAssetTransformations: { orgName: string; transformations: Transformation[]; repositoryId: string }[] = [];
    searchAssetToAssetTransformations: { orgName: string; transformations: Transformation[]; repositoryId: string }[] = [];
    searchOrAssetToAssetTransformations: { orgName: string; transformations: Transformation[]; repositoryId: string }[] = [];
    selectedTransformationName: string;
    selectedAssetToAssetTrnsName: string;
    selectedSearchAssetToAssetTrnsName: string;
    selectedsearchOrAssetToAssetTrnsName: string;
    sourceTableData = new BehaviorSubject([]);
    sourceTableColumns = [
        {
            name: 'name',
            displayName: 'Source Name',
            show: true,
            type: 'text',
        },
        {
            name: 'sourceDataFormat',
            displayName: 'Supported Format',
            show: true,
            type: 'text',
        },
        {
            name: 'from',
            displayName: 'Choose File',
            show: true,
            type: 'file',
        },
        {
            name: 'downloadSourceTemplate',
            displayName: 'Download Source Template',
            show: true,
            type: 'link',
        },
        {
            name: 'fileExtension',
            displayName: 'File Extension',
            show: false,
            type: 'text',
        },
    ];
    transformationSources = [];
    selectedRepositoryTransformations: any;
    selectedTransformation: Transformation;
    selectedAssetToAssetTransformation: Transformation;
    selectedSearchAssetToAssetTransformation: Transformation;
    selectedSearchOrAssetToAssetTransformation: Transformation;
    allSubscribedApps: AssetService[] = [];
    scrollToBottom = new BehaviorSubject(0);
    allInputTypes = [];
    allTenants: any;
    tempAllTenants: any;
    allTenantsTree: any[];
    allTenantsMap: {};
    tenantsToRender: any;
    subTenants: any[];
    selectedTenant: OrganizationData;
    selectedTenantId: string;
    parentOrgId: any;
    selectedSubTenant: Organization;
    subTentantToParentStructure: string[];
    filterSubTenantName: string;
    filterTenantName: string;
    selectAllOrganizations: boolean;
    filteringAttributes = [];
    notificationPopupMessage: string;
    sourceRestApiName: string;
    existInstanceId: string;
    requestId: string;
    navigateToEdit: boolean | null;
    hidePaginator = true;
    primaryColumns = ['Source Name', 'Supported Format'];
    filingAttributeFieldValues;
    masterEntityFieldValueMap: { [property: string]: string } = {};
    private unsubscribe = new Subject<void>();
    public selectedFilter: string;
    public searchedFilter: string;
    private uploadTabTimeout: ReturnType<typeof setTimeout>;
    public selectedIndex = 0;
    public saveFilterName = '';
    public isSavedFilterViewed = false;
    public searchAssetMetaData: any;
    public searchMap: any;
    public saveFilterDisabled = false;
    public statuses: { [property: string]: string[] } = {};
    public actualAssetId: string;
    public manualTemplate: any;
    public fileUpload: any;
    public pullFromApp: any;
    private appMetaSubscription: { [property: string]: Subscription } = {};
    private appMetaPromise: { [property: string]: any } = {};

    constructor(
        private _api: ApiService,
        public _utils: UtilsService,
        private _AssetsService: AssetsService,
        private dialog: MatDialog,
        private _validations: ValidationsService,
        private _fileUpload: FileUpload,
        private _instances: InstancesService,
        private _transformations: TransformationsService,
        private _requests: RequestsService,
        private _commonUtils: CommonUtilsService,
        public R: RootScope,
        public _newProcessService: NewProcessService,
        private store$: Store,
        private actions$: Actions
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes.filingAttributeFields &&
            changes.filingAttributeFields.currentValue &&
            changes.filingAttributeFields.currentValue.length > 0
        ) {
            this.filingAttributeFieldValues = this._commonUtils.getFromStorage('filingAttributeFields');
            if (
                this.filingAttributeFieldValues &&
                this.filingAttributeFieldValues !== 'undefined' &&
                this.filingAttributeFieldValues.length > 0
            ) {
                this.getFieldValues(this.filingAttributeFieldValues, this.filingAttributeFields);
            }
            this.initiateStepper();
            this.getBusinessKeyFieldValues();
        }
        if (changes.serviceId && changes.serviceId.currentValue && !changes.serviceId.firstChange) {
            this.serviceId = changes.serviceId.currentValue;
            this.unsubscribe.next();
            this.initializeSubscriptions();
            this.store$.dispatch(GetAssetWithLatestVersion({ serviceId: this.currentApp.serviceId }));
            this.startComponent();
        }
    }

    startComponent = async () => {
        if (this.filingAttributeFields && this.filingAttributeFields.length > 0) {
            this.filingAttributeFieldValues = this._commonUtils.getFromStorage('filingAttributeFields');
            if (
                this.filingAttributeFieldValues &&
                this.filingAttributeFieldValues !== 'undefined' &&
                this.filingAttributeFieldValues.length > 0
            ) {
                this.getFieldValues(this.filingAttributeFieldValues, this.filingAttributeFields);
            }
            this.getBusinessKeyFieldValues();
        }
        this.initiateStepper();
        if (this.currentBridge && this.currentBridge.restApiName) {
            this.getBridgeSourceNodes();
        }
        this.store$.dispatch(
            GetActiveTransformationsByType({
                noAlerts: false,
                serviceId: this.currentApp?.serviceId,
                restApiName: this.currentApp?.restApiName,
                transformationType: 'INBOUND',
                forceFetch: true,
            })
        );
        this.store$.dispatch(
            GetInboundDetailedTransformations({
                serviceId: this.currentApp.serviceId,
                assetMetaUid: this.currentApp?.assetMetaUId || this.actualAssetId,
                restApiName: this.currentApp?.restApiName,
                forceFetch: true,
                noAlerts: false,
            })
        );
    };

    private initiateStepper = () => {
        const filteredFilingAttributes = this.filingAttributeFields?.filter(field => !field.autoCalculate && field.show);
        this.stepper && (this.stepper.selectedIndex = filteredFilingAttributes?.length > 0 ? 0 : 1);
    };

    getFieldValues = (fillingAttributeValues, fields) => {
        fillingAttributeValues.forEach(fillingAttributes => {
            fields.forEach(field => {
                if (fillingAttributes.id === field.id) {
                    this.filingAttributeFields.filter(element => {
                        if (element.id === fillingAttributes.id) {
                            if (element.dataType === 'boolean') {
                                if (fillingAttributes.value === 'true') {
                                    element.value = true;
                                } else {
                                    element.value = false;
                                }
                            } else {
                                element.value = fillingAttributes.value;
                            }
                        }
                    });
                }
            });
        });
    };

    resetFilingAttributes = () => {
        this._commonUtils.setInStorage('filingAttributeFields', undefined);
    };

    validateFilingAttributeFields = (callback?: any) => {
        this._newProcessService
            .validateFilingAttributeFields({
                app: this.currentApp,
                bridge: this.currentBridge,
                filingAttributeFields: this.filingAttributeFields,
            })
            .then(() => {
                this.getBusinessKeyFieldValues();
                if (callback) {
                    callback();
                } else if (this.stepper) {
                    this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
                    if (this.bridgeSourceNodes && this.bridgeSourceNodes.length > 0) {
                        this.selectedIndex = 2;
                    } else if (this.transformations?.length > 0) {
                        this.selectUploadTab();
                    } else {
                        this.selectElectronicForm();
                    }
                } else {
                    if (this.bridgeSourceNodes && this.bridgeSourceNodes.length > 0) {
                        this.selectedIndex = 2;
                    } else if (this.transformations?.length > 0) {
                        this.selectUploadTab();
                    } else {
                        this.selectElectronicForm();
                    }
                }
            });
    };

    getBridgeSourceNodes = () => {
        this.bridgeSourceNodes = [];
        this._AssetsService.getBridgeSourceNodes(
            {
                service: this.currentApp,
                bridge: this.currentBridge,
            },
            {
                successCallback: res => {
                    if (res?.response?.sourceNodes) {
                        res.response.sourceNodes.forEach(element => {
                            this.bridgeSourceNodes.push(element);
                        });
                    }
                },
                failureCallback: () => {},
            }
        );
    };

    getBusinessKeyFieldValues = () => {
        this.businessKeysRecord?.fields?.forEach(field => {
            if (field) {
                const faField = this.filingAttributeFields?.find(element => element.id === field.id || element.fullId === field.id);
                const value = faField ? faField.value : this.getFilteringAttributeFieldValue(field);
                if (value !== undefined && value !== null) {
                    field.value = value;
                    if (value !== '') {
                        if (field.message?.errors) {
                            field.message.errors = [];
                        }
                        if (faField?.message?.errors) {
                            faField.message.errors = [];
                        }
                    }
                }
            }
        });
    };

    copyBusinessKeyErrorsToFilingAttributes = () => {
        this.businessKeysRecord?.fields?.forEach(bkField => {
            const faField = this.filingAttributeFields?.find(element => element.id === bkField.id || element.fullId === bkField.id);
            if (faField) {
                if (!faField.message) {
                    faField.message = { errors: [], warnings: [] } as any;
                }
                faField.message.errors = bkField.message?.errors ? [...bkField.message.errors] : [];
            }
        });
    };

    getFilteringAttributeFieldValue = field => {
        let fieldValue;
        this.filingAttributeFields?.forEach(element => {
            if (element.id === field.id || element.fullId === field.id) {
                fieldValue = element.value;
            }
        });
        return fieldValue;
    };

    isFieldInFilingAttributes = (field: any): boolean => {
        return this.filingAttributeFields?.some(
            element => !element.autoCalculate && element.show && (element.id === field.id || element.fullId === field.id)
        );
    };

    selectUploadTab = () => {
        if (this.selectedIndex === 1) {
            if (!this.selectedTransformationName && this.transformations?.length > 0) {
                this.selectFirstTransformation();
            }
            return;
        }
        clearTimeout(this.uploadTabTimeout);
        if (!this.inputTypeGroup || !document.hasFocus()) {
            this.uploadTabTimeout = setTimeout(() => {
                this.selectUploadTab();
            }, 1000);
            return;
        }
        this.selectedIndex = 1;
        this.selectFirstTransformation();
    };

    selectFirstTransformation = () => {
        const transObj = this.transformations;
        if (transObj?.length > 0) {
            const trans = transObj[0].transformations;
            if (trans?.length > 0) {
                this.selectedTransformationName = trans[0].id;
                this.getSelectedTransformation();
            }
        }
    };

    getSelectedTransformation = () => {
        this.transformationSources = [];
        if (this.selectedTransformationName?.length > 0) {
            for (let i = 0; i < this.transformations.length; i++) {
                for (let j = 0; j < this.transformations[i].transformations.length; j++) {
                    if (this.selectedTransformationName === this.transformations[i].transformations[j].id) {
                        this.selectedRepositoryTransformations = this.transformations[i];
                        this.selectedTransformation = this.transformations[i].transformations[j];
                        this.transformationSources = CommonUtilsService.cloneObject(this.transformations[i].transformations[j].sourceParts);
                    }
                }
            }
            this.scrollToBottm();
        }
        this.buildTableData();
    };

    getSelectedAssetToAssetTransformation = () => {
        this.transformationSources = [];
        if (this.selectedAssetToAssetTrnsName && this.selectedAssetToAssetTrnsName.length > 0) {
            for (let i = 0; i < this.assetToAssetTransformations.length; i++) {
                for (let j = 0; j < this.assetToAssetTransformations[i].transformations.length; j++) {
                    if (this.selectedAssetToAssetTrnsName === this.assetToAssetTransformations[i].transformations[j].id) {
                        this.selectedAssetToAssetTransformation = this.assetToAssetTransformations[i].transformations[j];
                    }
                }
            }

            if (this.selectedAssetToAssetTransformation.isAssetToAsset === true) {
                this.getFilteringAttributes();
            }
            if (!this.tenantsToRender || (this.tenantsToRender && this.tenantsToRender.length === 0)) {
                this._newProcessService.getAllTenantsForFlatStructure().then(data => {
                    this.tenantsToRender = data.tenantsToRender;
                    this.subTenants = data.subTenants;
                    this.selectedTenantId = data.selectedTenantId;
                    this.clearSearchSubTenant();
                });
            }
            if (this.selectedAssetToAssetTransformation.isSearchAsset == true) {
                this.selectedSearchAssetToAssetTrnsName = this.selectedAssetToAssetTrnsName;
                this.getSelectedSearchAssetToAssetTransformation();
            }
        }
    };

    getSelectedSearchAssetToAssetTransformation = () => {
        if (this.selectedSearchAssetToAssetTrnsName && this.selectedSearchAssetToAssetTrnsName.length > 0) {
            for (let i = 0; i < this.searchAssetToAssetTransformations.length; i++) {
                for (let j = 0; j < this.searchAssetToAssetTransformations[i].transformations.length; j++) {
                    if (this.selectedSearchAssetToAssetTrnsName === this.searchAssetToAssetTransformations[i].transformations[j].id) {
                        this.selectedSearchAssetToAssetTransformation = this.searchAssetToAssetTransformations[i].transformations[j];
                        this.selectedSearchAssetToAssetTrnsName?.length > 0 && this.buildTransformationAsset();
                    }
                }
            }
        }
    };

    private buildTransformationAsset = () => {
        const transformation = this.selectedSearchAssetToAssetTransformation;
        transformation?.sourceParts
            ?.filter(sourcePart => !(sourcePart?.copyOf?.length > 0))
            .forEach(async source => {
                this.store$.dispatch(GetAppMetaData({ serviceId: source.appDetails.serviceId }));
                const appName = source?.sourceAssetOrMasterName;
                if (!appName) {
                    return;
                }
                let app = this.allSubscribedApps?.find(s => s.serviceName === appName);
                if (!app) {
                    app = await this.getAppThroughApi(appName);
                }
                if (!app) {
                    return;
                }
                this.store$.dispatch(GetAppSearchFilters({ serviceId: source.appDetails.serviceId }));
                source.appDetails.metaDataLoading = true;
                source.appDetails.metaData = await this.getAppMetaData(app);
                source.search = new Search(this._utils, app.serviceId);
                this.fetchProcessesStatus(source, () => {
                    source.search.pushFieldOptions(
                        'instanceStatus.raw',
                        this.statuses?.[source.appDetails.serviceId]?.reduce((options, status) => {
                            options.push({
                                name: status
                                    .split(' ')
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(' '),
                                value: status === 'process cancelled' ? 'request cancelled' : status,
                            });
                            return options;
                        }, [])
                    );
                });
                source.search.setSources(source.search.convertEntities(source.appDetails.metaData.entities));
                source.search.setSource(source.appDetails.metaData.getPrimaryEntity()?.uid);
                source.search.isAddRuleVisible = true;
                source.search.allowCollapse = true;
                source.search.allowRuleset = true;
                source.search.needSourceStructure = true;
                source.appDetails.metaDataLoading = false;
                this.getDefaultSearchFilters(source);
            });
    };

    private getAppThroughApi = (appName: string) => {
        return new Promise<AssetService>(resolve => {
            this.store$.dispatch(GetAppThroughAppName({ appName }));
            const appPromise = this.store$
                .select(getSubscribedApps$)
                .pipe(
                    filter(apps => !!apps?.find(a => a.serviceName === appName)),
                    takeUntil(this.unsubscribe)
                )
                .subscribe(apps => {
                    setTimeout(() => {
                        appPromise?.unsubscribe();
                    }, 10);
                    const app = CommonUtilsService.cloneObject(apps?.find(a => a.serviceName === appName));
                    resolve(app?.serviceId ? app : null);
                });
        });
    };

    private fetchProcessesStatus = (source: Transformation['sourceParts'][0], callback?: () => void) => {
        if (this.statuses?.[source?.appDetails?.serviceId]?.length > 0) {
            return callback?.();
        }
        const data = {
            serviceId: source.appDetails.serviceId,
            noAlerts: false,
        };
        this._api.requests.getStatusBasedProcesses(data).subscribe(
            (res: any) => {
                const statusData = Object.keys(res.response.statuses);
                for (let i = 0; i < statusData.length; i++) {
                    if (statusData[i] === 'request cancelled') {
                        statusData[i] = 'process cancelled';
                    }
                }
                this.statuses[source?.appDetails?.serviceId] = statusData;
                callback?.();
            },
            () => {}
        );
    };

    private getAppMetaData = (app: AssetService) => {
        this.store$.dispatch(
            GetAppMetaData({
                noAlerts: false,
                serviceId: app?.serviceId,
                assetId: app?.assetMetaUId,
            })
        );
        if (this.appMetaPromise[app.serviceId]) {
            return this.appMetaPromise[app.serviceId];
        }
        this.appMetaPromise[app.serviceId] = new Promise<any>(resolve => {
            this.appMetaSubscription[app.serviceId] = this.store$
                .select(getAppMetaData$(app.serviceId, app.assetMetaUId))
                .pipe(filter(data => data.templateUpdated && data.uid?.length > 0))
                .subscribe(_event => {
                    setTimeout(() => {
                        this.appMetaSubscription[app.serviceId]?.unsubscribe();
                        delete this.appMetaSubscription[app.serviceId];
                    }, 100);
                    resolve(CommonUtilsService.cloneObject(_event));
                });
        });
        return this.appMetaPromise[app.serviceId];
    };

    private getDefaultSearchFilters = async source => {
        const appName = source?.sourceAssetOrMasterName;
        const app = Object.values(this.allSubscribedApps).find(service => service.serviceName === appName);
        if (app && !app?.assetMetaUId) {
            app.assetMetaUId = await this.getAssetDetails(app.serviceId);
        }
        const assetId = app?.assetMetaUId;
        if (!assetId) {
            return;
        } else {
            source.defaultSearchFilters = {};
            this._api.instances.getDefaultSearchFilters(assetId).subscribe({
                next: res => {
                    if (res?.['default-filters']?.length) {
                        source.defaultSearchFilters = res;
                        let cachedDefaultFilters = CommonUtilsService.getFromStorage('defaultFilters');
                        if (cachedDefaultFilters) {
                            cachedDefaultFilters[assetId] = res;
                        } else {
                            cachedDefaultFilters = {};
                            cachedDefaultFilters[assetId] = res;
                        }
                        CommonUtilsService.setInStorage('defaultFilters', cachedDefaultFilters);
                    }
                    this.searchMap[source.search.serviceId]['searchFilters'] && this.getSavedSearchFilters(source);
                },
                error: () => {},
            });
        }
    };

    private getAssetDetails = (serviceId: string) => {
        return new Promise<string>(resolve => {
            this.store$.dispatch(GetAssetWithLatestVersion({ serviceId }));
            const assetPromise = this.store$
                .select(getAssetsWithLatestVersion$)
                .pipe(
                    takeUntil(this.unsubscribe),
                    filter(versionsMap => !!versionsMap?.[serviceId]?.metadataId)
                )
                .subscribe(asset => {
                    setTimeout(() => {
                        assetPromise?.unsubscribe();
                    }, 10);
                    resolve(asset?.[serviceId]?.metadataId);
                });
        });
    };

    bindingTemplateValues = source => {
        const selectedFilterData = source.defaultSearchFilters['filterCriterias'][this.selectedFilter];
        source.search.setCriterias(selectedFilterData);
        if (this.selectedFilter) {
            this.searchMap[source.appDetails.serviceId].searchFilters.find(filter => filter.filterName === this.selectedFilter) &&
                (this.isSavedFilterViewed = true);

            source.search.criteriaUpdated = true;
            this.saveFilterName = this.selectedFilter;
        } else {
            this.isSavedFilterViewed = false;
            source.search.criteriaUpdated = false;
            this.saveFilterName = '';
        }
    };

    public getSavedSearchFilters = source => {
        source.defaultSearchFilters['default-filters'] ??
            (source.defaultSearchFilters = {
                'default-filters': [],
                filterCriterias: {},
            });
        const savedSearchFilters = this.searchMap[source.appDetails.serviceId].searchFilters;
        savedSearchFilters?.forEach(filter => {
            if (!source.defaultSearchFilters['default-filters']?.includes(filter.filterName)) {
                source.defaultSearchFilters['default-filters']?.push(filter.filterName);
            }
            source.defaultSearchFilters['filterCriterias'][filter.filterName] = JSON.parse(filter.criteria).search;
        });
    };

    public saveSearchFilter = (option, source) => {
        if (option === 'update') {
            this.saveFilterName = this.saveFilterName ? this.saveFilterName : '';
        }
        this.saveFilter(source);
    };

    public checkDefaultFilterExists = source => {
        return this.searchMap[source.appDetails.serviceId].defaultFilters?.['default-filters'].find(
            filter => filter === this.saveFilterName
        );
    };

    public checkSearchFilterExists = source => {
        return this.searchMap[source.appDetails.serviceId].searchFilters?.find(filter => filter.filterName === this.saveFilterName);
    };

    public saveFilter = source => {
        if (this.checkDefaultFilterExists(source)) {
            this._utils.alertError(
                `${translate('Filter')}: ${this.saveFilterName} ${translate('is a default filter and cannot be updated')}`
            );
            return;
        }
        if (this.checkSearchFilterExists(source) && !this.isSavedFilterViewed) {
            this._utils.alertError(`${translate('Filter')} ${this.saveFilterName} ${translate('Already Exists')}`);
            return;
        }
        if (!source.search.buildCriterias(true)) {
            this._utils.alertNotify(translate('Create Search Criteria From Rules Tab'));
        } else if (this.saveFilterName.trim().length === 0) {
            this._utils.alertError(translate('Enter valid filter name'));
        } else {
            const criteria = {
                search: source.search.optimizeCriteria(),
                sort: source.search.buildSortCriteria(),
            };
            const data: {
                criteria: string;
                filterName: string;
                serviceId: string;
                id?: string;
            } = {
                criteria: JSON.stringify(criteria),
                filterName: this.saveFilterName,
                serviceId: source.appDetails.serviceId,
            };
            const id = this.searchMap[source.search.serviceId]['searchFilters'].find(
                searchFilter => searchFilter.filterName === this.saveFilterName
            )?.id;
            id && (data.id = id);
            this.store$.dispatch(SaveSearchCriteria(data));
        }
    };

    getFilteringAttributes = () => {
        const group = this.getSelectedAssetToAssetTransformationGroup();
        this._AssetsService.getFilteringAttributes(
            {
                bridge: this.currentBridge,
                service: this.currentApp,
                transformationName: this.selectedAssetToAssetTransformation.name,
                repositoryId: group && group.repositoryId,
            },
            {
                successCallback: res => {
                    this.filteringAttributes = [];
                    if (res?.attributes?.length > 0) {
                        res.attributes
                            .filter(field => !field.autoCalculate)
                            .forEach(field => {
                                const entityField = this.assetMetaData.entities
                                    .find(entity => entity.uid === field.entityId)
                                    ?.fields?.find(f => f.uid === field.id);
                                this.filteringAttributes.push(new FilingAttributeField(field, entityField, this.assetMetaData.masters));
                            });
                        this.getFilteringAttributesValues();
                    }
                },
                failureCallback: () => {},
            }
        );
    };

    getFilteringAttributesValues = () => {
        this.filteringAttributes
            .filter(field => field && !field.autoCalculate)
            .forEach(field => {
                const value = this.getFilteringAttributeFieldValue(field);
                field.value = value;
            });
    };

    getSelectedAssetToAssetTransformationGroup = () => {
        let group;
        for (let i = 0; i < this.assetToAssetTransformations.length; i++) {
            for (let j = 0; j < this.assetToAssetTransformations[i].transformations.length; j++) {
                if (this.assetToAssetTransformations[i].transformations[j].id === this.selectedAssetToAssetTrnsName) {
                    group = this.assetToAssetTransformations[i];
                    break;
                }
            }
            if (group) {
                break;
            }
        }
        return group;
    };

    buildTableData = () => {
        this.sourceTableData.next(this.transformationSources);
    };

    selectElectronicForm = () => {
        this.selectedIndex = 0;
    };

    cancelEntity = (requestId?) => {
        this.navigateToProcesses.emit(requestId);
    };

    goToBackPage = () => {
        if (this.stepper) {
            this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
        } else {
            if (this.selectedIndex > 0) {
                this.selectedIndex = this.selectedIndex - 1;
            }
        }
    };

    initiateNewProcess = async (isFromEdit?: boolean) => {
        isFromEdit && this.navigateToEditPage.emit(isFromEdit);
        this.getBusinessKeyFieldValues();
        const isValid = await this.validateBusinessKeys();

        if (isValid) {
            switch (this.selectedIndex) {
                case 0:
                    this.submitAttributeFields(isFromEdit);
                    break;
                case 1:
                    this.uploadFile();
                    break;
                case 2:
                    this.selectedAssetToAssetTransformation?.isSearchAsset
                        ? this.startSearchAssetTransformation()
                        : this.startAssetToAssetTransformation();
                    break;
            }
        }
    };

    goToReview = async () => {
        const isValid = await this.validateBusinessKeys();
        isValid && this.goToNextPage();
    };

    validateBusinessKeys = async () => {
        if (this.selectedIndex !== 0) {
            if (this.selectedIndex === 1) {
                if (this.selectedTransformationName?.length > 0) {
                    const sources = this.sourceTableData.value;
                    let count = 0;
                    let sourceFileFound = 0;
                    sources.forEach(source => {
                        if (source.files) {
                            sourceFileFound = sourceFileFound + 1;
                            const givenFileFormat = source.files[0].name.substring(source.files[0].name.lastIndexOf('.'));
                            const requiredFileFormats = [];
                            requiredFileFormats.push(source.fileExtension);
                            requiredFileFormats.push('.zip');
                            if (requiredFileFormats.indexOf(givenFileFormat.toLowerCase()) === -1) {
                                count = count + 1;
                            }
                        }
                    });
                    if (!sourceFileFound) {
                        this._utils.alertError(translate('Please upload a file'));
                        return false;
                    } else {
                        if (count) {
                            this._utils.alertError(translate('Please select valid file format'));
                            return false;
                        } else {
                            return true;
                        }
                    }
                } else {
                    this._utils.alertError(translate('Please select transformation'));
                    return false;
                }
            } else if (this.selectedIndex === 2) {
                if (this.bridgeSourceNodes && this.bridgeSourceNodes.length > 0) {
                    return true;
                } else {
                    if (this.selectedAssetToAssetTrnsName && this.selectedAssetToAssetTrnsName.length > 0) {
                        const selectedTenantIds = [];
                        const allTenantsMap = this.getAllTenantMap();
                        for (const key in allTenantsMap) {
                            const tenant = allTenantsMap[key];
                            if (tenant && tenant.selected) {
                                selectedTenantIds.push(tenant.id);
                            }
                        }
                        if (this.filteringAttributes?.length > 0 || this.selectedAssetToAssetTransformation.isSearchAsset === true) {
                            const isValid = this._newProcessService.validateFilingAttributes(this.filteringAttributes);
                            if (isValid && selectedTenantIds && selectedTenantIds.length > 0) {
                                return true;
                            } else if (isValid && selectedTenantIds && selectedTenantIds.length === 0) {
                                this._utils.alertError(translate('Please select atleast one location'));
                                return false;
                            } else {
                                this._utils.alertError(translate('Please fix issues to proceed'));
                                return false;
                            }
                        } else {
                            if (!selectedTenantIds || selectedTenantIds.length > 0) {
                                this._utils.alertError(translate('Please select atleast one location'));
                                return false;
                            }
                        }
                    } else {
                        this._utils.alertError(translate('Please select transformation'));
                        return false;
                    }
                }
            }
        } else {
            const record: Record = CommonUtilsService.cloneObject(this.businessKeysRecord);
            if (record && record.fields) {
                for (let i = record.fields.length - 1; i >= 0; i--) {
                    if (!record.fields[i].isBusinessKey) {
                        record.fields.splice(i, 1);
                    }
                }
                if (record.fields.length === 0) {
                    return true;
                }
            }
            if (this.businessKeysRecord === undefined) {
                return true;
            }
            if (this.businessKeysRecord) {
                await this.checkAppVersion();
                const success = await this._validations.hasValidData({
                    configurations: [],
                    entities: this.assetMetaData.entities,
                    entityId: this.businessKeysRecord.entityId,
                    process: undefined,
                    record: this.businessKeysRecord,
                    restAPIName: this.assetMetaData.restAPIName,
                    inSearch: false,
                });
                this.copyBusinessKeyErrorsToFilingAttributes();
                if (!success) {
                    this._utils.alertError('Fix issues to proceed');
                    return false;
                }
                return true;
            }
        }
    };

    private checkAppVersion = () => {
        return new Promise<void>(resolve => {
            if (this.assetMetaData?.uid === this.currentApp?.assetMetaUId || this.assetMetaData?.uid === this.actualAssetId) {
                resolve();
            }
            this.getAppMetaData(this.currentApp).then(metaData => {
                this.assetMetaData = metaData;
                resolve();
            });
        });
    };

    getAllTenantMap = () => this._newProcessService.allTenantsMap;

    goToNextPage = () => {
        if (this.stepper) {
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
            if (this.stepper.selectedIndex === 1) {
                if (this.transformations && this.transformations.length > 0) {
                    this.selectUploadTab();
                } else {
                    this.selectElectronicForm();
                }
            }
            if (this.stepper.selectedIndex === 2) {
                setTimeout(() => {
                    this.scrollToBottom.next(this.scrollToBottom.value + 1);
                });
            }
        } else {
            this.selectedIndex = 1;
            if (this.transformations && this.transformations.length > 0) {
                this.selectUploadTab();
            } else {
                this.selectElectronicForm();
            }
        }
    };

    scrollToBottm = (time?) => {
        let timeOut;
        if (time) {
            timeOut = time;
        } else {
            timeOut = 0;
        }
        setTimeout(() => {
            this.scrollToBottom.next(this.scrollToBottom.value + 1);
            if (this.nextBTnDiv) {
                const buttnElemt = this.nextBTnDiv && this.nextBTnDiv['_elementRef'] && this.nextBTnDiv['_elementRef']['nativeElement'];
                if (buttnElemt) {
                    buttnElemt.focus();
                }
            }
        }, timeOut);
    };

    submitAttributeFields = (isFromEdit?: boolean) => {
        this.navigateToEdit = isFromEdit;
        this.validateFilingAttributeFields(this.submit);
    };

    submit = () => {
        let errorsCount = 0;
        if (this.businessKeysRecord?.fields) {
            this.businessKeysRecord.fields
                .filter(field => !field.autoCalculate)
                .forEach(field => {
                    field.message.errors = [];
                    if (field.isBusinessKey) {
                        if (field.value === '' || field.value === undefined || field.value === null) {
                            field.message.errors.push(`Please enter ${field.displayName}`);
                            errorsCount++;
                        }
                    }
                });
        }
        if (errorsCount === 0) {
            this.submitNewRequestBusinessKeys();
        } else {
            this.copyBusinessKeyErrorsToFilingAttributes();
            this._utils.alertError(translate('Fix issues to proceed with the generation'), 3000, 'Failure');
        }
    };

    submitNewRequestBusinessKeys = async () => {
        const bridge = this.currentBridge;
        const service = this.currentApp;
        const report = this.currentReport;
        let isFirstAssetInBridge: boolean;
        if (bridge && bridge.assets && bridge.assets.length > 0) {
            for (let i = 0; i < bridge.assets.length; i++) {
                if (bridge.assets[i].id === service.assetMetaUId || bridge.assets[i].id === this.actualAssetId) {
                    if (bridge.assets[i].level === 0) {
                        isFirstAssetInBridge = true;
                    }
                    break;
                }
            }
        }
        let errorsCount = 0;
        this.businessKeysRecord?.fields
            ?.filter(field => !field.autoCalculate)
            .forEach(field => {
                field.message.errors = [];
                if (field && field.isBusinessKey && field.id === 'inv_doc_num') {
                    if (field.value && this._utils.checkForSpecialChars(field.value)) {
                        field.message.errors.push(translate('Special characters are not allowed'));
                        errorsCount++;
                    } else if ((field.value as any)?.length > 16) {
                        field.message.errors.push(translate('Maximum number of characters allowed is 16'));
                        errorsCount++;
                    }
                }
            });
        if (errorsCount === 0) {
            if (report) {
                this.createBridgeRequest(undefined);
            } else if (isFirstAssetInBridge) {
                await this.checkAppVersion();
                const payload = new RequestBusinessKeysPayload(
                    this.businessKeysRecord,
                    this.assetMetaData.getPrimaryEntity(),
                    this.currentApp,
                    this.currentBridge
                );
                this._requests.submitBusinessKeys(
                    {
                        bridge: this.currentBridge,
                        payload,
                        service: this.currentApp,
                    },
                    {
                        successCallback: () => {
                            this.createBridgeRequest(undefined);
                        },
                        failureCallback: res => {
                            if (res.response && res.response.AssetDataId && res.response.requestId) {
                                this.existInstanceId = res.response.AssetDataId;
                                const initialState = {
                                    requestId: res.response.requestId,
                                    instanceId: res.response.AssetDataId,
                                    assetId: (this.currentApp && this.currentApp.assetMetaUId) || this.actualAssetId,
                                    bridgeId: (this.currentBridge && this.currentBridge.assetMetaUId) || this.actualAssetId,
                                    bridgeRestAPIName: this.currentBridge && this.currentBridge.restApiName,
                                    bridgeSourceNodes: this.bridgeSourceNodes,
                                    assetRestApiName: this.currentApp && this.currentApp.restApiName,
                                    isAssetToAssetCase: false,
                                    filingAttributeFields: this.filingAttributeFields,
                                };
                                const dialogRef = this.dialog.open(UpdateRequestComponent, {
                                    panelClass: ['updateRequestModalClass', 'matDialogContainer'],
                                    disableClose: true,
                                    data: {
                                        ...initialState,
                                    },
                                });
                                dialogRef.componentInstance.backToNewProcesspage = this.resetBackToFirstPage;
                                dialogRef.componentInstance.navigateToInstancePage = this.navigateInstances;
                            } else {
                                this._utils.alertError(res?.msg || res?.response?.msg || translate('Failed to save business keys'));
                            }
                        },
                    }
                );
            } else {
                this.createBridgeRequest(true);
            }
        } else {
            this._utils.alertError(translate('Fix issues to proceed with the generation'), 3000, 'Failure');
        }
    };

    private createBridgeRequest = (isNotFirstAssetInBridge?) => {
        const bridge = this.currentBridge;
        const report = this.currentReport;
        if (report) {
            this.getNewRequestIdWithBusinessKeys();
        } else if (bridge && bridge.restApiName && bridge.restApiName.length > 0) {
            /**
             * if bridge exists then the instance has to be pulled into the asset.
             */
            const formData = new FormData();
            const record: Record = this.businessKeysRecord;
            const fieldIds = [];
            record?.fields
                ?.filter(field => !field.autoCalculate && field.isBusinessKey)
                .forEach(field => {
                    formData.append(field.id, field.value as string);
                    fieldIds.push(field.id);
                });
            if (this.filingAttributeFields?.length > 0) {
                this.filingAttributeFields
                    .filter(field => !field.autoCalculate && fieldIds.indexOf(field.fullId) == -1 && field.value !== undefined)
                    .forEach(field => {
                        if (Array.isArray(field.value)) {
                            fieldIds.push(field.fullId);
                            field.value.forEach(element => {
                                formData.append(field.fullId, element);
                            });
                        } else {
                            formData.append(field.fullId, field.value);
                            fieldIds.push(field.fullId);
                        }
                    });
            }
            this._instances.createInstanceFromBridge(
                {
                    bridge: this.currentBridge,
                    isNotFirstAssetInBridge,
                    payload: formData,
                    service: this.currentApp,
                    isAssetToAssetTransformation: false,
                },
                {
                    successCallback: res => {
                        this.requestId = res.response.requestId ? res.response.requestId : res.response;
                        this._utils.alertSuccess((res && res.msg) || translate('Request created successfully'));
                        this.resetFilingAttributes();
                        this._utils.showLoading();
                        setTimeout(
                            () => {
                                this._utils.hideLoading();
                                if (this.navigateToEdit) {
                                    this.navigateToProcesses.emit(this.requestId);
                                } else {
                                    this.navigateToInboundTransmissionsFromNewProcessPage.emit(this.requestId);
                                }
                            },
                            bridge?.restApiName?.length > 0 ? 5000 : 0
                        );
                    },
                    failureCallback: res => {
                        this._utils.alertError(
                            (res && res.msg) || (res && res.response && res.response.msg) || translate('Failed to create new request')
                        );
                    },
                }
            );
        } else {
            this.getNewRequestIdWithBusinessKeys();
        }
    };

    private getNewRequestIdWithBusinessKeys = () => {
        const formData = new FormData();
        const record: Record = this.businessKeysRecord;
        const fieldIds = [];
        record?.fields
            ?.filter(field => !field.autoCalculate && field.isBusinessKey)
            .forEach(field => {
                const value: string = field.value as string;
                formData.append(field.id, value);
                fieldIds.push(field.id);
            });
        this.filingAttributeFields
            ?.filter(field => !field.autoCalculate && fieldIds.indexOf(field.fullId) === -1 && field.value !== undefined)
            .forEach(field => {
                if (Array.isArray(field.value)) {
                    field.value.forEach(element => {
                        formData.append(field.fullId, element);
                    });
                } else {
                    formData.append(field.fullId, field.value);
                }
            });
        this._requests
            .createNewRequest({
                payload: formData,
                service: this.currentApp,
                bridge: this.currentBridge as AssetService,
                report: this.currentReport as BridgeNode,
            })
            .then(res => {
                if (res.response && (res.response as any).REQUEST_EXISTS) {
                    this.existInstanceId = res.response.REQUEST_EXISTS;
                    const initialState = {
                        requestId: '',
                        instanceId: res.response.REQUEST_EXISTS,
                        assetId: (this.currentApp && this.currentApp.assetMetaUId) || this.actualAssetId,
                        bridgeId: (this.currentBridge && this.currentBridge.assetMetaUId) || this.actualAssetId,
                        bridgeRestAPIName: this.currentBridge && this.currentBridge.restApiName,
                        bridgeSourceNodes: this.bridgeSourceNodes,
                        assetRestApiName: this.currentApp && this.currentApp.restApiName,
                        isAssetToAssetCase: false,
                    };
                    const dialogRef = this.dialog.open(UpdateRequestComponent, {
                        panelClass: ['updateRequestModalClass', 'matDialogContainer'],
                        disableClose: true,
                        data: {
                            ...initialState,
                        },
                    });
                    dialogRef.componentInstance.backToNewProcesspage = this.resetBackToFirstPage;
                    dialogRef.componentInstance.navigateToInstancePage = this.navigateInstances;
                } else if (this.isEninvoice) {
                    this.resetFilingAttributes();
                    this.navigateToProcesses.emit(res.response?.requestId || '');
                } else {
                    this.requestId = res.response && res.response.requestId;
                    this._utils.alertSuccess((res && res.msg) || translate('Failed to create new request'));
                    this.resetFilingAttributes();
                    this._utils.showLoading();
                    setTimeout(() => {
                        this._utils.hideLoading();
                        if (this.navigateToEdit) {
                            this.navigateToProcesses.emit(this.requestId);
                        } else {
                            this.navigateToInboundTransmissionsFromNewProcessPage.emit(this.requestId);
                        }
                    }, 5000);
                }
            })
            .catch(res => {
                if (res && res.response && res.response.REQUEST_EXISTS) {
                    this.existInstanceId = res.response.REQUEST_EXISTS;
                    const initialState = {
                        requestId: '',
                        instanceId: res.response.REQUEST_EXISTS,
                        assetId: (this.currentApp && this.currentApp.assetMetaUId) || this.actualAssetId,
                        bridgeId: (this.currentBridge && this.currentBridge.assetMetaUId) || this.actualAssetId,
                        bridgeRestAPIName: this.currentBridge && this.currentBridge.restApiName,
                        bridgeSourceNodes: this.bridgeSourceNodes,
                        assetRestApiName: this.currentApp && this.currentApp.restApiName,
                        isAssetToAssetCase: false,
                    };
                    const dialogRef = this.dialog.open(UpdateRequestComponent, {
                        panelClass: ['updateRequestModalClass', 'matDialogContainer'],
                        disableClose: true,
                        data: {
                            ...initialState,
                        },
                    });
                    dialogRef.componentInstance.backToNewProcesspage = this.resetBackToFirstPage;
                    dialogRef.componentInstance.navigateToInstancePage = this.navigateInstances;
                } else {
                    this._utils.alertError(
                        (res && res.msg) || (res && res.response && res.response.msg) || translate('Failed to create new request')
                    );
                }
            });
    };

    uploadFile = async (isFromEdit?: boolean) => {
        this.navigateToEdit = isFromEdit;
        const formData = new FormData();
        const sources = this.sourceTableData.value;
        sources.forEach(source => {
            source.files?.forEach(file => {
                const isIE = this._utils.isIEBrowser();
                if (isIE) {
                    formData.append(source.name, file, file.name);
                } else {
                    formData.append(source.name, file);
                }
            });
        });
        this.filingAttributeFields
            .filter(field => !field.autoCalculate && field.value !== undefined)
            .forEach(field => {
                if (Array.isArray(field.value)) {
                    field.value.forEach(element => {
                        formData.append(field.fullId, element);
                    });
                } else {
                    formData.append(field.fullId, field.value);
                }
            });
        const bridge = this.currentBridge;
        const app = this.currentApp;
        let url = this.taxillaApiUrl + '/process/v1/' + app.restApiName + '?sourceType=UPLOAD';
        if (bridge?.restApiName) {
            url += '&bridgeRestApiName=' + bridge.restApiName;
        }
        url += '&transformationName=' + this.selectedTransformation.chainName;
        this._fileUpload.uploadRequest(
            'POST',
            url,
            formData,
            undefined,
            res => {
                this._utils.hideLoading();
                if (this.isEninvoice) {
                    this._utils.alertSuccess(
                        res &&
                            translate(
                                "File has been uploaded. However, it might take some while to process the data based on the volume. Kindly refresh after some time if you don't see the records."
                            )
                    );
                } else {
                    this._utils.alertSuccess((res && res.msg) || translate('Files has been uploaded'));
                }
                if (this.navigateToEdit) {
                    setTimeout(() => {
                        this.navigateToProcesses.emit(res?.response?.requestId);
                    }, 500);
                } else {
                    this.navigateToInboundTransmissionsFromNewProcessPage.emit(res?.response?.requestId);
                }
            },
            res => {
                this._utils.hideLoading();
                this._utils.alertError((res && res.msg) || translate('Failed to upload files'));
            }
        );
    };

    getSelectedGroup = () => {
        let group;
        for (let i = 0; i < this.transformations.length; i++) {
            for (let j = 0; j < this.transformations[i].transformations.length; j++) {
                if (this.transformations[i].transformations[j].name === this.selectedTransformation.name) {
                    group = this.transformations[i];
                    break;
                }
            }
            if (group) {
                break;
            }
        }
        return group;
    };

    startAssetToAssetTransformation = (isFromEdit?: boolean) => {
        this.navigateToEdit = isFromEdit;
        if (this.bridgeSourceNodes && this.bridgeSourceNodes.length > 0) {
            const payload = new FormData();
            this.filingAttributeFields
                .filter(field => !field.autoCalculate && field.value !== undefined)
                .forEach(field => {
                    if (Array.isArray(field.value)) {
                        field.value.forEach(element => {
                            payload.append(field.fullId, element);
                        });
                    } else {
                        payload.append(field.fullId, field.value);
                    }
                });

            this._instances.createInstanceFromBridge(
                {
                    bridge: this.currentBridge,
                    isNotFirstAssetInBridge: true,
                    payload,
                    service: this.currentApp,
                    isAssetToAssetTransformation: true,
                },
                {
                    successCallback: res => {
                        if (res && res.response && res.response.pendingAssetDataIds) {
                            this.notificationPopupMessage =
                                'There exists some pending processes matching the criteria! Please complete them before proceeding with the current process.';
                            this.sourceRestApiName = res.response.restApiName;
                            this.dialog.open(this.notificationModal, {
                                panelClass: ['newProcessNotificaionModal', 'matDialogContainer'],
                                disableClose: true,
                            });
                        } else {
                            this.postInitiationOfRequest(res);
                        }
                    },
                    failureCallback: res => {
                        this.processIncompleteData(res);
                    },
                }
            );
        } else {
            const payload = new FormData();
            const attributes = [];
            [...(this.filteringAttributes || []), ...(this.filingAttributeFields || [])]
                .filter(field => !field.autoCalculate)
                .forEach(field => {
                    attributes.push(field);
                });
            const playloadFieldIds = [];
            attributes.forEach(field => {
                if (playloadFieldIds.includes(field.fullId)) {
                    return;
                }
                playloadFieldIds.push(field.fullId);
                if (field.value !== undefined) {
                    if (Array.isArray(field.value)) {
                        field.value.forEach(element => {
                            payload.append(field.fullId, element);
                        });
                    } else {
                        payload.append(field.fullId, field.value);
                    }
                }
            });
            const selectedTenantIds = [];
            const allTenantsMap = this.getAllTenantMap();
            for (const key in allTenantsMap) {
                const tenant = allTenantsMap[key];
                if (tenant && tenant.selected) {
                    selectedTenantIds.push(tenant.id);
                }
            }
            if (selectedTenantIds.length === 0) {
                return this._utils.alertError('Select locations');
            }
            payload.append('unitIds', this._utils.convertJSONtoBlob(selectedTenantIds));
            this._transformations.processTransformations(
                {
                    bridgeRestAPIName: this.currentBridge && this.currentBridge.restApiName,
                    restApiName: this.currentApp && this.currentApp.restApiName,
                    transformationName: this.selectedAssetToAssetTransformation.chainName,
                    payload,
                    override: false,
                },
                {
                    successCallback: res => {
                        if (res && res.response && res.response.pendingAssetDataIds) {
                            this.notificationPopupMessage =
                                'There exists some pending processes matching the criteria! Please complete them before proceeding with the current process.';
                            this.sourceRestApiName = res.response.restApiName;
                            this.dialog.open(this.notificationModal, {
                                panelClass: ['newProcessNotificaionModal', 'matDialogContainer'],
                                disableClose: true,
                            });
                        } else {
                            this.postInitiationOfRequest(res);
                        }
                    },
                    failureCallback: res => {
                        this._utils.alertError((res && res.msg) || translate('Failed to start transformation'));
                    },
                }
            );
        }
    };

    startSearchAssetTransformation = async () => {
        const selectedTenantIds = [];
        this.subTenants.forEach(tenant => {
            if (tenant.selected) {
                selectedTenantIds.push(tenant.id);
            }
        });
        if (selectedTenantIds.length === 0) {
            return this._utils.alertError(translate('Select locations'));
        }
        const transformation = this.selectedSearchAssetToAssetTransformation;
        const sourceParts = transformation?.sourceParts;
        const payloadPromise = this.getAssetToAssetCriteria(sourceParts, selectedTenantIds);
        payloadPromise
            .then(payload => {
                const requestData = new FormData();
                requestData.append('dataSources', JSON.stringify(payload));
                const playloadFieldIds = [];
                const attributes = [];
                [...(this.filteringAttributes || []), ...(this.filingAttributeFields || [])]
                    .filter(field => !field.autoCalculate)
                    .forEach(field => {
                        attributes.push(field);
                    });
                attributes.forEach(field => {
                    if (playloadFieldIds.includes(field.fullId)) {
                        return;
                    }
                    playloadFieldIds.push(field.fullId);
                    if (field.value !== undefined) {
                        if (Array.isArray(field.value)) {
                            field.value.forEach(element => {
                                requestData.append(field.fullId, element);
                            });
                        } else {
                            requestData.append(field.fullId, field.value);
                        }
                    }
                });
                this.store$.dispatch(
                    CreateRequestViaSearch({
                        serviceId: this.currentApp.serviceId,
                        payload: requestData,
                        transformationName: this.selectedSearchAssetToAssetTransformation?.chainName,
                    })
                );
            })
            .catch(e => {
                this.store$.dispatch(AlertError({ message: e }));
            });
    };

    private getAssetToAssetCriteria = (sourceParts: Transformation['sourceParts'], locationIds: string[]) => {
        return new Promise((resolve, reject) => {
            const promises = [];
            sourceParts
                ?.filter(part => !part.copyOf && part.appDetails?.metaData)
                .forEach(sourcePart => {
                    promises.push(this.getSourcePartCriteria(sourcePart, locationIds));
                });
            Promise.all(promises).then(([...criterias]) => {
                if (criterias.filter(criteria => criteria !== undefined).length === 0) {
                    reject(translate('Create search criteria to proceed'));
                }
                const payload = [...criterias.filter(criteria => criteria !== undefined)];
                resolve(payload);
            });
        });
    };

    private getSourcePartCriteria = async (sourcePart: Transformation['sourceParts'][0], locationIds: string[]) => {
        const appDetails = sourcePart?.appDetails;
        if (!sourcePart?.search?.criteriaUpdated) {
            return undefined;
        }
        const criteria = sourcePart?.search.optimizeCriteria();
        const updatedLocationIds = locationIds;
        criteria.unitConsiderationEnabled = false;
        return {
            type: 'SearchCriteriaDataSourceType',
            name: sourcePart?.name,
            searchCriteria: {
                filterCriteria: criteria,
                restApiServiceName: appDetails.restApiName,
                unitIds: updatedLocationIds,
            },
        };
    };

    postInitiationOfRequest = responseObj => {
        if (responseObj?.response?.REQUEST_EXISTS?.length > 0) {
            const instanceId = responseObj.response.REQUEST_EXISTS;
            this._instances
                .getInstance({
                    instanceId,
                    serviceId: this.getServiceId(),
                    noAlerts: false,
                })
                .then(instance => {
                    const requestId = instance.assetRequests?.[0]?.requestId;
                    this.existInstanceId = responseObj.response.REQUEST_EXISTS;
                    const initialState = {
                        requestId: responseObj.response.requestId || requestId,
                        instanceId: responseObj.response.REQUEST_EXISTS,
                        assetId: (this.currentApp && this.currentApp.assetMetaUId) || this.actualAssetId,
                        bridgeId: (this.currentBridge && this.currentBridge.assetMetaUId) || this.actualAssetId,
                        bridgeRestAPIName: this.currentBridge && this.currentBridge.restApiName,
                        bridgeSourceNodes: this.bridgeSourceNodes,
                        assetRestApiName: this.currentApp && this.currentApp.restApiName,
                        isAssetToAssetCase: true,
                        filingAttributeFields: this.filingAttributeFields,
                    };
                    const dialogRef = this.dialog.open(UpdateRequestComponent, {
                        panelClass: ['updateRequestModalClass', 'matDialogContainer'],
                        disableClose: true,
                        data: {
                            ...initialState,
                        },
                    });
                    dialogRef.componentInstance.backToNewProcesspage = this.resetBackToFirstPage;
                    dialogRef.componentInstance.updateAssetRequest = this.updateAssetRequest;
                    dialogRef.componentInstance.navigateToInstancePage = this.navigateInstances;
                    dialogRef.componentInstance.processIncompleteInstances = this.processIncompleteData;
                });
        } else {
            this._utils.alertSuccess((responseObj && responseObj.msg) || 'Asset to Asset pull request created sucessfully');
            if (this.navigateToEdit) {
                this.navigateToProcesses.emit(responseObj?.response?.requestId);
            } else {
                this.navigateToInboundTransmissionsFromNewProcessPage.emit(responseObj?.response?.requestId);
            }
        }
    };

    navigateInstances = () => {
        this.navigateToInstancePage.emit(this.existInstanceId);
    };

    getServiceId = (): string => {
        const app = this.currentApp;
        const bridge = this.currentBridge;
        const report = this.currentReport;
        if (report) {
            return (bridge && bridge.serviceId) || (app && app.serviceId);
        } else if (bridge) {
            return app.serviceId ? app.serviceId : bridge.serviceId + '.' + app.serviceId;
        }
        return app && app.serviceId;
    };

    updateAssetRequest = () => {
        const payload = new FormData();
        const attributes = [];
        [...(this.filteringAttributes || []), ...(this.filingAttributeFields || [])]
            .filter(field => !field.autoCalculate)
            .forEach(field => {
                attributes.push(field);
            });
        const playloadFieldIds = [];
        attributes.forEach(field => {
            if (playloadFieldIds.includes(field.fullId)) {
                return;
            }
            playloadFieldIds.push(field.fullId);
            if (field.value !== undefined) {
                if (Array.isArray(field.value)) {
                    field.value.forEach(element => {
                        payload.append(field.fullId, element);
                    });
                } else {
                    payload.append(field.fullId, field.value);
                }
            }
        });
        const selectedTenantIds = [];
        this.subTenants.forEach(tenant => {
            if (tenant.selected) {
                selectedTenantIds.push(tenant.id);
            }
        });
        if (selectedTenantIds.length === 0) {
            return this._utils.alertError(translate('Select locations'));
        }
        payload.append('unitIds', this._utils.convertJSONtoBlob(selectedTenantIds));
        this._transformations.processTransformations(
            {
                bridgeRestAPIName: this.currentBridge && this.currentBridge.restApiName,
                restApiName: this.currentApp && this.currentApp.restApiName,
                transformationName: this.selectedAssetToAssetTransformation.chainName,
                payload,
                override: true,
            },
            {
                successCallback: res => {
                    this._utils.alertSuccess((res && res.msg) || translate('Asset To Asset Pull Request Accepted'));
                    this.dialog.closeAll();
                    this.navigateToInstancePage.emit(this.existInstanceId);
                },
                failureCallback: res => {
                    this._utils.alertError((res && res.msg) || translate('Failed to start transformation'));
                },
            }
        );
    };

    processIncompleteData = res => {
        if (res && res.response && res.response.pendingAssetDataIds) {
            this.notificationPopupMessage = translate(
                'There exists some pending processes matching the criteria! Please complete them before proceeding with the current process'
            );
            this.sourceRestApiName = res.response.restApiName;
            this.dialog.open(this.notificationModal, {
                panelClass: ['newProcessNotificaionModal', 'matDialogContainer'],
                disableClose: true,
            });
        } else {
            this._utils.alertError((res && res.msg) || translate('Failed to start transformation'));
        }
    };

    resetBackToFirstPage = () => {
        if (this.filingAttributeFields && this.filingAttributeFields.length > 0) {
            if (this.stepper) {
                this.stepper.selectedIndex = 0;
            } else {
                this.selectedIndex = 0;
            }
        } else {
            if (this.stepper) {
                this.stepper.selectedIndex = 1;
                if (this.transformations && this.transformations.length > 0) {
                    this.selectUploadTab();
                } else {
                    this.selectElectronicForm();
                }
            } else {
                this.selectedIndex = 1;
                if (this.transformations && this.transformations.length > 0) {
                    this.selectUploadTab();
                } else {
                    this.selectElectronicForm();
                }
            }
        }
    };

    processSourceInstances = () => {
        const data = {
            targetAssetRestApiName: this.currentApp && this.currentApp.restApiName,
            sourceAssetRestApiName: this.sourceRestApiName,
            filingAttributeFields: this.filingAttributeFields,
        };
        this.navigateToSourceAsset.emit(data);
        this.dialog.closeAll();
    };

    closePopup = () => {
        this.dialog.closeAll();
    };

    downloadSourceTemplateUrl = async data => {
        await this.checkAppVersion();
        const url =
            `${environment['catalogue_api']}/v2/services/${encodeURIComponent(this.currentApp.restApiName)}/user-template` +
            `?transformationName=${encodeURIComponent(this.selectedTransformation.chainName)}` +
            `&sourceName=${encodeURIComponent(data.name)}`;
        window.open(url);
    };

    selectTenantAndSubTenantsForTransformation = (tenant: Organization, selected: boolean) => {
        this.subTenants = this._newProcessService.tenantPreOrderTraversal(tenant, []);
        this.subTenants.forEach(subTenant => (subTenant['selected'] = selected));
        this.addSelectedTotenantsMap(tenant, selected);
        this.scrollToBottm();
    };

    addSelectedTotenantsMap = (tenant: Organization, selected: boolean) => {
        this.allTenantsMap ??= this.getAllTenantMap();
        if (this.allTenantsMap[tenant.id]) {
            this.allTenantsMap[tenant.id].selected = selected;
        } else {
            this.allTenantsMap[tenant.id] = {
                ...tenant,
                selected,
            };
        }
        this.selectAllOrganizations = this.subTenants.every(tenant => tenant.selected);
    };

    toggleTenants = (tenant: Organization) => {
        this.selectAllOrganizations = !this.selectAllOrganizations;
        this.subTenants = this._newProcessService.tenantPreOrderTraversal(tenant, []);
        this.subTenants.forEach(subTenant => (subTenant['selected'] = this.selectAllOrganizations));
        this.scrollToBottm();
    };

    selectIfParentOrg = (event, tenant) => {
        this.addSelectedTotenantsMap(tenant, event);
        this.scrollToBottm();
    };

    checkSubTenant = subTenant => {
        if (subTenant.selected) {
            subTenant.selected = false;
            this.addSelectedTotenantsMap(subTenant, false);
        } else {
            subTenant.selected = true;
            this.addSelectedTotenantsMap(subTenant, true);
        }
        this.scrollToBottm();
    };

    clearSearchSubTenant = () => {
        this.filterSubTenantName = '';
    };

    IECheck = (): void => {
        if (FileReader.prototype.readAsBinaryString === undefined) {
            FileReader.prototype.readAsBinaryString = function (fileData) {
                const onLoadHandler = this.onload;
                const reader = new FileReader();
                reader.onload = function () {
                    const blobURL = URL.createObjectURL(fileData);
                    const xhr = new XMLHttpRequest();
                    xhr.open('get', blobURL);
                    xhr.overrideMimeType('text/plain; charset=x-user-defined');
                    xhr.onload = function () {
                        const g = {
                            target: {
                                result: xhr.response,
                            },
                        };
                        typeof onLoadHandler === 'function' && onLoadHandler(g);
                    };
                    xhr.send();
                };
                reader.readAsArrayBuffer(fileData);
            };
        }
    };

    private delayStartCompleteProcess = () => {
        setTimeout(() => {
            this.startComponent();
        }, 1000);
    };

    private initializeSubscriptions = () => {
        combineLatest([this.store$.select(getCurrentOrganization$), this.store$.select(getFileUploadTransformations$(this.restApiName))])
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(async ([currentOrgMap, data]) => {
                if (data?.length > 0) {
                    const repositoryIds = [...new Set(data.map(item => item.repositoryId))];
                    const orgIdVsNames = await this._api.locations.getOrgNamesByIds({
                        orgIds: repositoryIds,
                        noAlerts: false,
                    });
                    const providerOrgId = currentOrgMap?.providerOrganizationId;
                    this.transformations = CommonUtilsService.cloneObject(
                        data.map(tr => ({
                            ...tr,
                            orgName:
                                providerOrgId && tr.repositoryId === providerOrgId
                                    ? 'Default'
                                    : orgIdVsNames[tr.repositoryId] || tr.orgName,
                        }))
                    );
                    const orgHierarchy: string[] = [];
                    let org = currentOrgMap;
                    while (org) {
                        orgHierarchy.push(org.id);
                        org = org.parent;
                    }
                    const getPriority = (repoId: string) => {
                        if (repoId === providerOrgId) return 1000;
                        const index = orgHierarchy.indexOf(repoId);
                        if (index !== -1) return index;
                        return 500;
                    };
                    this.transformations?.sort((a, b) => getPriority(a.repositoryId) - getPriority(b.repositoryId));
                    setTimeout(() => {
                        this.selectedTransformation = undefined;
                        this.selectedTransformationName = undefined;
                        this.selectedAssetToAssetTrnsName = undefined;
                        this.selectedAssetToAssetTransformation = undefined;
                        this.selectUploadTab();
                    }, 1000);
                } else {
                    this.selectElectronicForm();
                }
            });

        this.store$
            .select(getSearchOrAssetToAssetTransformations$(this.restApiName))
            .pipe(
                takeUntil(this.unsubscribe),
                filter(data => data !== undefined && JSON.stringify(this.transformations) !== JSON.stringify(data))
            )
            .subscribe(data => {
                this.assetToAssetTransformations = CommonUtilsService.cloneObject(data);
            });
        this.actions$.pipe(ofType(SavedSearchCriteria), takeUntil(this.unsubscribe)).subscribe(action => {
            const source = this.selectedSearchAssetToAssetTransformation?.sourceParts.find(
                source => source.appDetails.serviceId === action.serviceId
            );
            if (!source) {
                return;
            }
            this.saveFilterDisabled = true;
        });
        this.actions$.pipe(ofType(SetAppSearchFilters), takeUntil(this.unsubscribe)).subscribe((action: any) => {
            const source = this.selectedSearchAssetToAssetTransformation?.sourceParts.find(
                source => source.appDetails.serviceId === action.serviceId
            );
            if (!source) {
                return;
            }
            this.getSavedSearchFilters(source);
        });
        this.store$
            .select(getAppSearchOrganizationMap$)
            .pipe(
                takeUntil(this.unsubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(data => {
                this.searchMap = data;
            });
        this.store$
            .select(getSearchAssetTransformations$(this.restApiName))
            .pipe(
                takeUntil(this.unsubscribe),
                filter(data => data !== undefined && JSON.stringify(this.transformations) !== JSON.stringify(data))
            )
            .subscribe(data => {
                this.searchAssetToAssetTransformations = CommonUtilsService.cloneObject(data);
            });
        this.store$
            .select(getSearchOrAssetToAssetTransformations$(this.restApiName))
            .pipe(
                takeUntil(this.unsubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(data => {
                this.searchOrAssetToAssetTransformations = CommonUtilsService.cloneObject(data);
            });
        this.store$
            .select(getSubscribedApps$)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(data => {
                this.allSubscribedApps = CommonUtilsService.cloneObject(data).filter(app => app.assetType !== 'PACKAGE');
            });
        this.actions$.pipe(ofType(SetRequest), takeUntil(this.unsubscribe)).subscribe(data => {
            const res = data?.requestResponse;
            if (res?.response?.pendingAssetDataIds) {
                this.notificationPopupMessage =
                    'There exists some pending processes matching the criteria! Please complete them before proceeding with the current process.';
                this.sourceRestApiName = res.response.restApiName;
                this.dialog.open(this.notificationModal, {
                    panelClass: ['newProcessNotificaionModal', 'matDialogContainer'],
                    disableClose: true,
                });
            } else {
                this.postInitiationOfRequest(res);
            }
        });
        this.store$
            .select(getAssetsWithLatestVersion$)
            .pipe(
                takeUntil(this.unsubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(data => {
                this.actualAssetId = data?.[this.serviceId]?.metadataId;
                if (this.currentApp?.serviceId === this.serviceId) {
                    this.currentApp.assetMetaUId = this.actualAssetId;
                }
            });
    };

    ngOnInit() {
        this.R.isInCreateNewPage = true;
        this.initializeSubscriptions();
        this.delayStartCompleteProcess();
        if (this._utils.isIEBrowser()) {
            this.IECheck();
        }
        this.store$.dispatch(GetAssetWithLatestVersion({ serviceId: this.serviceId }));
    }

    tabClick = (tabIndex: number) => {
        this.selectedIndex = tabIndex;
    };

    ngOnDestroy() {
        this.R.isInCreateNewPage = false;
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
